// extracted by mini-css-extract-plugin
export default {"wrapper":"Zd","form":"_d","label":"ae","asterisk":"be","smallprint":"ce","noMargin":"de","success":"ee","circle":"fe"};